export default {
  segmentDDApiKey: 'L3UWqZFYa0jF2PtgpEsKod2WtZet4Zvr',
  segmentCaviarApiKey: 'ctJaPszdHTeUJeaiMgfH5IFNFxo9gTcq',
}

export const RiskActions = {
  PhoneEmailVerify: 'phone_email_verify',
  PaymentCardNotVerified: 'payment_card_not_verified',
  RegisterCallback: 'register_callback',
  Reset: 'reset',
  VerificationRequired: 'verification_required',
}

export const RiskWorkflows = {
  ChangePassword: 'change_password',
  DasherLogin: 'dasher_login',
  DasherLoginUpdatePhone: 'dasher_login_update_phone',
  DasherSignup: 'dasher_signup',
  DeleteAccount: 'delete_account',
  EditPhoneOnCheckout: 'edit_phone_on_checkout',
  EditProfile: 'edit_profile',
  PlaceOrder: 'place_order',
  SelfHelp: 'self_help',
}
